export default __webpack_public_path__ + "static/media/aboutme.258dc050.png";